export default function mapLoqateToFormFields(address = {}) {
  return {
    houseNumberOrName: address.BuildingNumber || address.BuildingName,
    address: address.Line1,
    addressLineTwo: address.Line2,
    city: address.City,
    county: address.ProvinceName || address.AdminAreaName,
    postalCode: address.PostalCode,
  }
}